import React from "react"
import { useTranslation } from "react-i18next"

import { Raw } from "~/components/raw"

import styles from "./index.module.css"

export const EmptyFilter: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.Wrapper}>
      <Raw html={t("FilterWrapper.EmptyFilter")} />
    </div>
  )
}
